import React from 'react';
import { match } from 'ts-pattern';

import type { SchemaLinkTypeType } from '@fragment/types/schemas';
import { Icon } from '@fragment/ui/src/components/Icon/BaseIcon/Icon';

export const getLinkedAccountIcon = (
  linkType: SchemaLinkTypeType | undefined,
  size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
) => {
  if (!linkType) return null;
  const icon = match(linkType)
    .with('IncreaseLink', () => (
      <Icon data-testid="increaseLink-icon" type="increaseLink" size={size} />
    ))
    .with('StripeLink', () => (
      <Icon data-testid="stripeLink-icon" type="stripeLink" size={size} />
    ))
    .with('UnitLink', () => (
      <Icon data-testid="unitLink-icon" type="unitLink" size={size} />
    ))
    .with('CustomLink', () => (
      <Icon
        data-testid="customSyncLink-icon"
        type="customSyncLink"
        size={size}
      />
    ))
    .exhaustive();
  return <span className="flex flex-row items-center">{icon}</span>;
};

export const getPaymentAccountIcon = (
  size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
) => (
  <span className="flex flex-row items-center">
    <Icon
      data-testid="paymentBadge-icon"
      type="fragmentLogoCircle"
      size={size}
    />
  </span>
);
